import Listagem from '../componentes/IVenda/Listagem';
import Cadastro from '../componentes/IVenda/Cadastro';

function IVenda(props) {  
  
  return (

    <section>

      { props.acao === "Listar" &&
        <Listagem />
      }
      { props.acao !== "Listar" &&
        <Cadastro acao={props.acao} />
      }    

    </section>

  );

}

export default IVenda;
